import { Badge } from '../../ui/badge';
import { ticketPriorityClass, ticketPriorityLabel } from '../../../data/crmTicketConstants';

export default function CrmTicketPriorityBadge({ priority }) {
  return (
    <Badge variant="secondary" className={ticketPriorityClass(priority)}>
      {ticketPriorityLabel(priority)}
    </Badge>
  );
}
